const __request = require(`../__request/__request_contentType_json`);

// 国内退款记录数
export default (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/buyer/dom/manage/reimburseCount',
    data:data
  }

  return __request(pParameter)
}

